<template>
  <div class="couponPage" style="margin-top: 10px">
    <div class="page-section">
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick(activeName)"> -->
      <!-- <el-tab-pane label="点券账户充值" name="ADDSCORE"> -->
      <div class="page-section-tab">
        <!-- <div
          class="page-section-tab-item"
          :class="activeName === 'MALL_WALLET' ? 'page-section-tab-activeItem' : ''"
          @click="handleClick('MALL_WALLET')"
        >
          <img
            :src="
              activeName === 'MALL_WALLET'
                ? 'https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/platForm/WalletOutlined%402x.png'
                : 'https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/platForm/WalletOutlined%402x%20(1).png'
            "
            alt=""
          />
          <div>
            <div class="page-section-tab-item-title" :style="{color:activeName === 'MALL_WALLET' ? 'rgba(0, 191, 148, 1)' : 'rgba(0,0,0,0.6);'}">现金账户充值</div>
            <div class="page-section-tab-item-desc">
              现金用于支付办签时使领馆收取的签证费用
            </div>
          </div>
        </div> -->
        <!-- <div
        @click="handleClick('ADDSCORE')"
          class="page-section-tab-item"
          :class="activeName === 'ADDSCORE' ? 'page-section-tab-activeItem' : ''"
        >
          <img
            :src="
              activeName === 'ADDSCORE'
                ? 'https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/platForm/ic_dianquan%402x%20(1).png'
                : 'https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/platForm/ic_dianquan%402x.png'
            "
            alt=""
          />
          <div>
            <div class="page-section-tab-item-title" :style="{color:activeName === 'ADDSCORE' ? 'rgba(0, 191, 148, 1)' : 'rgba(0,0,0,0.6);'}">点券账户充值</div>
            <div class="page-section-tab-item-desc">
              点券用于支付使用闪电签平台签证工具服务的增值服务费
            </div>
          </div>
        </div> -->
      </div>
      <div
        class="page-section-recharge-amount"
        v-if="activeName === 'ADDSCORE'"
        v-loading="couponRechargeAuthLoading"
      >
        <template v-if="offlineCouponRecharge">
          <div class="page-section-recharge-amount-title">
            {{ $t('financial.recharge.couponRechargeTitle') }}
          </div>
          <div class="page-section-recharge-amount-count">
            <span>{{ $t('financial.recharge.couponBalanceLabel') }}</span>
            <span>{{ balance.score | filterToYuan }}</span>
          </div>
        </template>
        <template v-else-if="!couponRechargeAuthLoading">
          <div class="page-section-recharge-amount-title">{{ $t('financial.recharge.selectAmountTitle') }}</div>
          <div class="page-section-recharge-amount-desc">
            {{ $t('financial.recharge.selectAmountDesc') }}
          </div>
          <div class="page-section-recharge-amount-count">
            <span>{{ $t('financial.recharge.couponBalance') }}</span>
            <span>{{ balance.score | filterToYuan }} {{ $t('common.couponUnit') }}</span>
          </div>
        </template>
      </div>
      <div
        class="page-section-offline-recharge"
        v-if="activeName === 'ADDSCORE' && offlineCouponRecharge"
      >
        <p class="page-section-offline-recharge-notice">
          {{ $t('financial.recharge.offlineNoticePrimary') }}
        </p>
        <p class="page-section-offline-recharge-subnotice">
          {{ $t('financial.recharge.offlineNoticeSecondary') }}
        </p>
        <div class="page-section-offline-recharge-contact">
          <div class="page-section-offline-recharge-contact-item">
            <p class="page-section-offline-recharge-contact-label">
              {{ $t('financial.recharge.servicePhone') }}
            </p>
            <p class="page-section-offline-recharge-contact-value">
              {{ $t('financial.recharge.servicePhoneNo') }}
            </p>
          </div>
          <div class="page-section-offline-recharge-contact-item">
            <p class="page-section-offline-recharge-contact-label">
              {{ $t('financial.recharge.serviceWechat') }}
            </p>
            <img
              class="page-section-offline-recharge-contact-qrcode"
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/tool/iwEcAqNwbmcDAQTRBF4F0QRmBrBms4fLqV0-BQoGvzxRVUAAB9IAt--qCAAJomltCgAL0gAGpwI.png"
              :alt="$t('financial.recharge.serviceWechat')"
            />
          </div>
        </div>
      </div>
      <div
        class="page-section-countList"
        v-if="activeName === 'ADDSCORE' && showOnlineCouponRecharge"
      >
        <div
          class="page-section-countList__item"
          v-for="(item, index) in scoreAmount"
          :key="index"
          @click="handleClickIndex(item)"
          :class="
            item.label == chooseAmount ? 'page-section-countList__selectedItem' : ''
          "
        >
          <div class="page-section-countList__item-price">
            {{ item.label }}
          </div>
          <div class="page-section-countList__item-text">{{ $t('common.couponUnit') }}</div>
        </div>
      </div>
      <div class="page-section-payable" v-if="showOnlineCouponRecharge">
        <div class="page-section-payable-title">
          <span>{{ $t('financial.payment.payable') }}</span>
          <span>{{ $t('financial.recharge.rateHint') }}</span>
        </div>
        <div class="page-section-payable-bck">
          {{ formatPayableAmount(chooseAmount) }}
        </div>
      </div>
      <!-- </el-tab-pane> -->
      <!-- <el-tab-pane label="现金账户充值" name="MALL_WALLET"> -->
      <div class="page-section-wallet-amount" v-if="activeName === 'MALL_WALLET'">
        <div class="page-section-wallet-amount-title">{{ $t('financial.recharge.cashInputTitle') }}</div>
        <div class="page-section-wallet-amount-desc">
          {{ $t('financial.recharge.cashInputDesc') }}
        </div>
        <div class="page-section-wallet-amount-balance">
          <span>{{ $t('financial.recharge.cashBalance') }}</span>
          <span>{{ balance.mallBalance | filterToYuan }} {{ $t('common.yuan') }}</span>
        </div>
        <div class="page-section-wallet-amount-input">
          <el-input
            @input="handleInput"
            :placeholder="$t('financial.payment.inputAmount')"
            type="number"
            v-model="chooseAmount"
          ></el-input>
          <span>{{ $t('common.yuan') }}</span>
        </div>
        <div class="page-section-wallet-amount-payable">{{ $t('financial.payment.payable') }}</div>
        <div class="page-section-wallet-amount-payableNum">
          {{ chooseAmount ? chooseAmount : "0.00" }} {{ $t('common.yuan') }}
        </div>
      </div>
    </div>
    <el-card v-if="chooseAmount && showOnlinePayment">
      <div class="page-section-payType" v-loading="payStatus">
        <div class="page-section-payType-title">{{ $t('financial.payment.payMethod') }}</div>
        <div class="page-section-payType-box">
          <div class="page-section-payType-box-scan">
            <div class="page-section-payType-box-scan-header">{{ $t('financial.payment.scanPay') }}</div>
            <img
              class="page-section-payType-box-scan-url"
              :src="payScanData.codeImgUrl"
              alt=""
            />
            <p>{{ $t('financial.payment.scanHint') }}</p>
            <img
              src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/img_pay_ali%402x.png"
              alt=""
              class="page-section-payType-box-scan-alipay"
            />
            <img
              src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/img_pay_we%402x.png"
              alt=""
              class="page-section-payType-box-scan-wechat"
            />
          </div>
          <div class="page-section-payType-box-bank">
            <div class="page-section-payType-box-bank-header">{{ $t('financial.payment.bankTransfer') }}</div>
            <img
              src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/ic_bank%402x.png"
              alt=""
            />
            <p>{{ $t('financial.payment.accountNo') }}</p>
            <p>571911902610901</p>
            <p>{{ $t('financial.payment.accountName') }}</p>
            <p>{{ $t('financial.payment.bankAccountName') }}</p>
            <p>{{ $t('financial.payment.bankName') }}</p>
            <p>{{ $t('financial.payment.bankBranch') }}</p>
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog :visible.sync="payDialogSync" class="payDialogSync" width="400px">
      <div class="payDialogSync-content">
        <i class="el-icon-success payDialogSync-i"></i>
        <span class="payDialogSync-text">{{ $t('financial.payment.rechargeSuccess') }}</span>
      </div>
      <div slot="footer" class="payDialogSync-footer">
        <el-button type="primary" @click="handleRefresh">{{ $t('financial.payment.continueRecharge') }}</el-button>
        <el-button type="primary" @click="handleRecode">{{ $t('financial.payment.viewRecords') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment, { months } from "moment";
import * as toolApi from "@/apis/tool";
import * as financialApi from "@/apis/financial";
import * as accountApi from "@/apis/account";
import { formatToYuan } from "@/utils/formatters";
import { getBaseURL } from "@/utils/util";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
export default {
  name: "coupon",
  data() {
    return {
      pollingPayStatus: null,
      payDialogSync: false,
      activeName: "ADDSCORE",
      tableHeight: 0,
      formatToYuan,
      chooseAmount: 5000,
      scoreAmount: [
        {
          amount: 500000,
          label: 5000,
        },
        {
          amount: 1000000,
          label: 10000,
        },
        {
          amount: 2000000,
          label: 20000,
        },
        {
          amount: 3000000,
          label: 30000,
        },
        {
          amount: 5000000,
          label: 50000,
        },
      ],
      countryDict: [],
      operatorDict: [],
      visaTypeDict: [],
      couponTypeDict: [],
      listData: [],
      payStatus: false,
      listInfo: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        countryId: "",
        date: [
          moment().subtract(90, "d").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
        dateFrom: moment().subtract(90, "d").format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        operatorId: "",
        orderBy: "",
        passportNum: "",
        type: "",
        typeId: "",
        username: "",
      },
      income: 0,
      expenditure: 0,
      listLoading: false,
      activeDateBtn: "",
      downloadLoading: false,
      payScanData: {},
      pollingBalance: null,
      offlineCouponRecharge: false,
      couponRechargeAuthLoading: false,
    };
  },
  created() {
    // console.log(this.$route.query.type, " 点券用于支付使用闪电签平台签证工具服务的 ");
    // if (!this.$route.query.type) return this.getPayScan();
  },
  mounted() {
    this.pollBalance();
    this.tableHeight = window.innerHeight - 366;
    this.getCountryDict();
    this.getOperatorDict();
    this.getCouponTypeDict();
    this.getCouponData();
    this.initCouponRechargeAccess();
  },
  destroyed() {
    //  this.pollingBalance = null
    clearInterval(this.pollingBalance);
  },
  computed: {
    ...mapGetters(["balance", "userInfo"]),
    showOnlineCouponRecharge() {
      return (
        this.activeName === "ADDSCORE" &&
        !this.couponRechargeAuthLoading &&
        !this.offlineCouponRecharge
      );
    },
    showOnlinePayment() {
      if (!this.chooseAmount) {
        return false;
      }
      if (this.activeName === "MALL_WALLET") {
        return true;
      }
      return this.showOnlineCouponRecharge;
    },
  },
  watch: {
    // "balance.mallBalance": {
    //   handler(newV, oldV) {
    //     console.log(newV, oldV, "val");
    //     if (oldV) {
    //       if (!!newV && newV != oldV) {
    //         console.log(newV);
    //         this.payDialogSync = true;
    //       }
    //     }
    //   },
    //   immediate: true,
    // },
    // "balance.score": {
    //   handler(newV, oldV) {
    //     if (oldV) {
    //       if (newV != oldV) {
    //         this.payDialogSync = true;
    //         this.pollPayStatus();
    //       }
    //     }
    //   },
    //   immediate: true,
    // },
    /**
     * @description
     * 从签证服务跳转到充值中心时，应默认选中现金账户
     * @return online string
     * */
    // $route: {
    //   handler(to, from) {
    //     if (to.query.type == "online") {
    //       this.activeName = "MALL_WALLET";
    //       this.chooseAmount = "";
    //     }
    //   },
    //   immediate: true, //第一次就执行
    // },
  },

  methods: {
    ...mapActions(["setBalance"]),
    async initCouponRechargeAccess() {
      if (this.activeName !== "ADDSCORE") {
        this.getPayScan();
        return;
      }
      this.couponRechargeAuthLoading = true;
      try {
        const country = (this.userInfo && this.userInfo.country) || "CHINA";
        if (country !== "CHINA") {
          this.offlineCouponRecharge = true;
          return;
        }
        const result = await accountApi.getAccountAuth();
        this.offlineCouponRecharge = !!(result && result.scoreOnlineRecharge === false);
        if (!this.offlineCouponRecharge) {
          this.getPayScan();
        }
      } catch (err) {
        this.getPayScan();
      } finally {
        this.couponRechargeAuthLoading = false;
      }
    },
    formatPayableAmount(amount) {
      return parseFloat(amount).toFixed(2) + this.$t('common.yuan')
    },
    handleRefresh() {
      this.$router.go(0);
    },
    handleRecode() {
      if (this.activeName === "ADDSCORE") {
        this.$router.push("/financial/coupon");
      } else {
        this.$router.push("/financial/mall");
      }
    },
    //  getPayStatus(data) {
    //   let payTimer = setInterval(async () => {
    //     const result = await toolApi.getPayStatus({ outTradeNo: data });
    //     if (result) {
    //       console.log(result, "result");
    //     }
    //   }, 2000);
    // },
    handleInput: _.debounce(function () {
      this.$forceUpdate();
      if (this.chooseAmount < 0) {
        this.chooseAmount = "";
      } else {
        this.getPayScan();
      }
    }, 1000),
    pollBalance() {
      let pollingBalance = setInterval(() => {
        this.setBalance();
      }, 3000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(pollingBalance);
      });
    },
    pollPayStatus() {
      this.pollingPayStatus = setInterval(async () => {
        let status = await this.getPayStatus();
        console.log(status, "status");
        if (status) {
          //最大轮询30次，及90秒后，关闭轮询
          clearInterval(this.pollingPayStatus);
        }
      }, 2000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.pollingPayStatus);
      });
    },
    async getPayStatus() {
      try {
        const result = await toolApi.getPayStatus({
          outTradeNo: this.payScanData.outTradeNo,
        });
        if (result) {
          if (result.payStatus === "TRADE_SUCCESS") {
            this.payDialogSync = true;
            return true;
          } else {
            return false;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPayScan() {
      this.payStatus = true;
      const result = await toolApi.getZmpayV2({
        payFromEnum: this.activeName,
        totalAmount: this.chooseAmount * 100,
        returnUrl: "https://b.visaai.com/pay-transfer.html",
      });
      if (result) {
        this.payStatus = false;
        this.payScanData = result;
        clearInterval(this.pollingPayStatus);
        this.pollPayStatus();
      } else {
        this.payStatus = false;
      }
    },
    handleClick(data) {
      this.activeName = data;
      if (data === "ADDSCORE") {
        this.chooseAmount = 5000;
        this.getPayScan();
        // if (this.$route.query.type) return this.getPayScan();
      } else {
        this.chooseAmount = "";
      }
    },
    handleClickIndex(data) {
      this.chooseAmount = data.label;
      this.getPayScan();
    },
    async getCountryDict() {
      const result = await toolApi.getCountryDict();
      if (result) {
        this.countryDict = result;
      }
    },
    async getVisaTypeDict(countryId) {
      const params = {
        countryId,
      };
      const result = await toolApi.getVisaTypeDict(params);
      this.visaTypeDict = result || [];
    },
    async getOperatorDict() {
      const params = {
        pageNum: 1,
        pageSize: 1000,
      };
      const result = await toolApi.getOperatorDict(params);
      if (result) {
        this.operatorDict = result.records || [];
      }
    },
    async getCouponTypeDict() {
      const result = await toolApi.getCouponTypeDict();
      if (result) {
        this.couponTypeDict = result;
      }
    },
    handleCountryChange(countryId) {
      this.listInfo.typeId = "";
      if (countryId) {
        this.getVisaTypeDict(countryId);
      } else {
        this.visaTypeDict = [];
      }
    },
    handleDateChange(value) {
      if (value && value[0] && value[1]) {
        this.listInfo.dateFrom = value[0];
        this.listInfo.dateTo = value[1];
      } else {
        this.listInfo.dateFrom = "";
        this.listInfo.dateTo = "";
      }
    },
    async getCouponData(pageNum = 1) {
      this.listLoading = true;
      try {
        this.listInfo.pageNum = pageNum;

        const result = await financialApi.getCouponData(this.listInfo);
        this.listLoading = false;

        if (result) {
          const {
            pageInfo: { records, pageNum, totalCount },
            expenditure,
            income,
          } = result;
          this.listData = records || [];
          this.listInfo = {
            ...this.listInfo,
            pageNum,
            totalCount,
          };
          this.expenditure = expenditure;
          this.income = income;
        }
      } catch (err) {
        this.listLoading = false;
        throw new Error(err);
      }
    },
    resetSearch() {
      this.listInfo = {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        countryId: "",
        date: [],
        dateFrom: "",
        dateTo: "",
        operatorId: "",
        orderBy: "",
        passportNum: "",
        type: "",
        typeId: "",
        username: "",
      };
      this.activeDateBtn = "";
      this.$refs.searchForm.clearValidate();
      this.getCouponData();
    },
    searchByDate(days) {
      const startDate = moment().subtract(days, "d").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");
      this.listInfo = {
        ...this.listInfo,
        dateFrom: startDate,
        dateTo: endDate,
        date: [startDate, endDate],
      };
      this.activeDateBtn = days;
      this.getCouponData();
    },
    async download() {
      this.downloadLoading = true;
      try {
        const result = await financialApi.downloadCouponData(this.listInfo);
        this.downloadLoading = false;
        if (result) {
          window.open(getBaseURL("api") + result);
        }
      } catch (err) {
        this.downloadLoading = false;
        throw new Error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.couponPage {
  width: 100%;
  height: 100vh;
  max-width: 1200px;
  min-width: 928px;

  &-data {
    color: $color-black-54;
    padding-left: 16px;
  }

  &-search__btns {
    color: $color-black-54;
    margin-bottom: 16px;

    &-today {
      cursor: pointer;

      &.active,
      &:hover {
        color: $color-green-dark;
      }
    }

    &-month {
      cursor: pointer;
      margin-right: 8px;

      &.active,
      &:hover {
        color: $color-green-dark;
      }
    }
  }

  .page-section {
    // padding: 16px 24px;
    border-radius: 4px;
    padding: 0;
    &-recharge {
      &-amount {
        margin-top: 24px;
        padding-left: 24px;
        position: relative;

        &-title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          margin-bottom: 8px;
        }

        &-desc {
          font-size: 13px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.38);
          margin-bottom: 24px;
        }

        &-count {
          position: absolute;
          right: 24px;
          top: 24px;

          span:nth-child(1) {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            margin-right: 8px;
          }

          span:nth-child(2) {
            font-size: 20px;
            font-weight: 500;
            color: #c89658;
          }
        }
      }
    }

    &-offline-recharge {
      padding: 0 24px 24px;

      &-notice {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: 500;
        color: #ff6f00;
        line-height: 22px;
      }

      &-subnotice {
        margin: 0 0 24px;
        font-size: 13px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.38);
        line-height: 20px;
      }

      &-contact {
        display: flex;
        gap: 16px;

        &-item {
          flex: 1;
          min-height: 160px;
          padding: 24px;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 4px;
          box-sizing: border-box;
        }

        &-label {
          margin: 0 0 16px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
        }

        &-value {
          margin: 0;
          font-size: 20px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
        }

        &-qrcode {
          width: 120px;
          height: 120px;
        }
      }
    }

    &-countList {
      padding-left: 24px;

      width: 664px;
      display: flex;

      &__item {
        cursor: pointer;
        margin-right: 8px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        background: rgba(0, 0, 0, 0.02);
        width: 160px;
        height: 80px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.12);
        padding: 12px;
        box-sizing: border-box;

        &-price {
          text-align: center;
          width: 160px;
          font-size: 24px;
          font-weight: 500;
          color: #00bf94;
        }

        &-text {
          text-align: center;
          width: 160px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
        }
      }

      &__selectedItem {
        background: #00bf94;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.12);

        div:nth-child(1) {
          text-align: center !important;
          width: 160px !important;
          font-size: 24px !important;
          font-weight: 500 !important;
          color: #fff !important;
        }

        div:nth-child(2) {
          text-align: center !important;
          width: 160px !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #ffffff !important;
        }
      }
    }

    &-payable {
      padding-left: 24px;
      margin-bottom: 24px;
      width: 664px;
      margin-top: 24px;

      &-title {
        span:nth-child(1) {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          margin-right: 16px;
        }

        span:nth-child(2) {
          font-size: 13px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.38);
        }
      }

      &-bck {
        height: 56px;
        background: rgba(255, 167, 38, 0.12);
        border-radius: 4px;
        padding: 10px 16px;
        box-sizing: border-box;
        font-size: 24px;
        font-weight: 500;
        color: #ff6f00;
        line-height: 36px;
        text-indent: 16px;
        margin-top: 16px;
      }
    }

    &-payType {
      width: 664px;

      &-title {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
      }

      &-box {
        display: flex;

        &-scan {
          position: relative;
          margin-right: 8px;

          &:after {
            content: "";
            position: absolute;
            right: -8px;
            top: 0;
            width: 1px;
            height: 330px;
            background: rgba(0, 0, 0, 0.08);
          }

          width: 320px;

          &-header {
            height: 48px;
            background: #eef9ff;
            border-radius: 4px;
            line-height: 48px;
            text-indent: 24px;
            font-size: 16px;
            font-weight: 500;
            color: #0094e8;
            margin: 16px 0;
          }

          &-url {
            width: 160px;
            height: 160px;
            margin-left: 24px;
          }

          p {
            margin-left: 24px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
          }

          &-alipay {
            width: 40px;
            height: 40px;
            margin-left: 24px;
          }

          &-wechat {
            width: 40px;
            height: 40px;
            margin-left: 17px;
          }
        }

        &-bank {
          margin-left: 8px;
          width: 328px;

          img {
            width: 56px;
            height: 56px;
            margin-left: 24px;
          }

          &-header {
            height: 48px;
            background: #eef9ff;
            border-radius: 4px;
            line-height: 48px;
            text-indent: 24px;
            font-size: 16px;
            font-weight: 500;
            color: #0094e8;
            margin: 16px 0;
          }

          p:nth-child(3) {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.38);
            margin: 16px 0 4px 24px !important;
          }

          p:nth-child(4) {
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
            margin: 0 0 8px 24px !important;
          }

          p:nth-child(5) {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.38);
            margin: 0 0 4px 24px !important;
          }

          p:nth-child(6) {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
            margin: 0 0 4px 24px !important;
          }

          p:nth-child(7) {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.38);
            margin: 0 0 4px 24px !important;
          }

          p:nth-child(8) {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
            margin: 0 0 4px 24px !important;
          }
        }
      }
    }

    &-wallet {
      &-amount {
        padding: 24px;
        position: relative;

        &-title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
        }

        &-desc {
          font-size: 13px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.38);
          margin: 8px 0 24px;
        }
        &-balance {
          position: absolute;
          right: 24px;
          top: 24px;

          span:nth-child(1) {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            margin-right: 8px;
          }

          span:nth-child(2) {
            font-size: 20px;
            font-weight: 500;
            color: #ff6f00;
          }
        }

        &-input {
          width: 664px;
          position: relative;

          input {
            height: 64px;
            font-size: 24px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
          }

          span:nth-child(2) {
            position: absolute;
            right: 14px;
            top: 14px;
            font-size: 24px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.38);
          }
        }

        &-payable {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          margin: 24px 0 16px;
        }

        &-payableNum {
          height: 56px;
          border-radius: 4px;
          background: rgba(255, 167, 38, 0.12);
          line-height: 56px;
          text-indent: 16px;
          color: #ff6f00;
          font-weight: 500;
          font-size: 24px;
        }
      }
    }
    &-tab {
      display: flex;
      border-radius: 0px 4px 0px 0px;
      &-item {
        width: 50%;
        height: 64px;
        background: rgba(0, 0, 0, 0.02);
        display: flex;
        align-items: center;
        padding: 16px 24px;
        box-sizing: border-box;
        cursor: pointer;
        img {
          width: 32px;
          height: 32px;
          margin-right: 16px;
        }
        &-title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
        }
        &-desc {
          font-size: 13px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.38);
        }
      }
      &-activeItem {
        background: rgba(0, 191, 148, 0.12);
      }
    }
  }
}
.payDialogSync {
  &-i {
    color: #00bf94;
    font-size: 50px;
    margin-right: 15px;
  }

  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    margin: 20px 0;
  }

  .payDialogSync-text {
    font-size: 20px;
  }

  &-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
